import MigrationManager from './MigrationManager'

import './1633740058931'

export default MigrationManager
